import script from "./FormLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormLabel.vue?vue&type=script&lang=ts&setup=true"

import "./FormLabel.vue?vue&type=style&index=0&id=7358675f&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7358675f"]])

export default __exports__